exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logotype{display:flex;flex-direction:row;align-items:center;justify-content:center;text-decoration:none;overflow:hidden}.logotype__image{width:100%;height:auto}", ""]);

// exports
